import { Flex } from '@uhg-abyss/web/ui/Flex';
import React from 'react';

import { ICircleBackgroundProps } from './types';

export const CircleBackground = ({
  fill,
  radius,
  ...otherProps
}: ICircleBackgroundProps) => {
  const diameter = radius * 2;
  return (
    <Flex
      {...otherProps}
      css={{
        width: diameter,
        height: diameter,
        backgroundColor: fill,
        borderRadius: radius,
      }}
    />
  );
};
